import { Box, Button, H2, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import urlBuilder from '../../../../Shared/url-builder';

export const OnDemandBillingTableHeader = () => (
  <Box
    css={{
      display: 'flex',
      justifyContent: 'space-between',
      borderRadius: 'large',
      pb: 'space.300',
    }}
  >
    <Box>
      <H2 variant="title200">On-demand billing</H2>
      <Text as="span" color="text.weak" variant="text50" css={{ fontWeight: '400' }}>
        You can view statements and CSV files by clicking into the rows below.
      </Text>
    </Box>
    <SambaAutoLink to={urlBuilder.getOnDemandBillingStartPage.absolute()}>
      <Button variant="solidPrimary">Upload fees</Button>
    </SambaAutoLink>
  </Box>
);
